<template>
  <article>
    <div class="img-wrapper">
      <template v-if="item.image">
        <img :src="item.image" :alt="item.header" />
      </template>
    </div>
    <div class="content">
      <h4 class="text-m" v-accent="item.header" v-if="item.header"></h4>
      <h5 class="accent text-s" v-accent="item.subheader" v-if="item.subheader"></h5>
      <h6 class="text-xs" v-accent="item.subheader2" v-if="item.subheader2"></h6>
      <p class="text-m" v-accent="item.description" v-if="item.description"></p>
    </div>
  </article>
</template>

<script>
export default {
  name: 'eventPreview',
  props: ['item']
}
</script>

<style scoped lang="scss">
  article {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    p {
      font-weight: 500;
    }
    h4 {
      text-transform: uppercase;
      margin: 20px 0 2px;
    }
    h5 {
      text-transform: uppercase;
      margin: 2px 0 4px;
    }
    h6 {
      margin: 0 0 22px;
      font-style: italic;
    }
    .img-wrapper {
      width: 36%;
      max-height: 100%;
      position: relative;
      overflow: hidden;
      margin-right: ($gap-md * 2);

      @include desktop {
        width: 44%;
      }
    }
    img {
      width: 100%;
      height: auto;
    }
    .content {
      width: 46%;
    }
    @include mobile {
      flex-direction: column-reverse;
      .img-wrapper {
        width: 100%;
        // min-height: 120vw;
        padding-bottom: $gap-md;
        position: relative;
        overflow: hidden;
      }
      // img {
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   width: 100%;
      //   // max-height: 100%;
      //   max-width: 100%;
      //   display: block;
      //   margin: 0 auto;
      // }
      .content {
        width: 100%;
      }
    } // END @include mobile;
  }
  a {
    text-decoration: none;
  }
</style>
